// IrnUpdate.jsx
import { Grid, Paper, Snackbar, styled, Alert, LinearProgress } from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import * as XLSX from 'xlsx';
import BillingReportsService from "../Services/Reports/BillingReportsService";
import Home from "./home/Home";

const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: "1px solid black",
  height: "100%",
}));

function IrnUpdate() {
  const mystyle = {
    border: "1px solid black",
    width: "100%",
    fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",
    fontFamily: 'Times New Roman',
  };

  // State Management
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setSeverit] = useState('info');
  const [uploading, setUploading] = useState(false);
  const [fileName, setFileName] = useState('');
  const [uploadStatus, setUploadStatus] = useState(null);
  const [excelData, setExcelData] = useState([]);
  const [apiResponse, setApiResponse] = useState(null);

  const handleClose = () => {
    setOpen(false);
  };

  const showMessage = (msg, severity = 'info') => {
    setMessage(msg);
    setSeverit(severity);
    setOpen(true);
  };

  // Convert Excel to JSON
  const excelToJson = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          resolve(jsonData);
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  };

  // Handle Excel file upload and send to API
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileName(file.name);
    setUploading(true);
    setUploadStatus('uploading');
    setApiResponse(null);
    
    try {
      // Convert Excel to JSON
      const jsonData = await excelToJson(file);
      
      if (jsonData.length === 0) {
        showMessage('Excel file is empty', 'warning');
        setUploadStatus('error');
        setUploading(false);
        return;
      }

      setExcelData(jsonData);
      
      // Send JSON to API
      const response = await BillingReportsService.update_irn_from_excel(jsonData);
      
      console.log('API Response:', response);
      
      // Check response status
      if (response && response.data) {
        const resData = response.data;
        
        setApiResponse(resData);
        
        if (resData.status === 'success' || resData.code === '200') {
          setUploadStatus('success');
          showMessage(resData.data || 'IRN updated successfully!', 'success');
        } else {
          setUploadStatus('error');
          showMessage(resData.message || resData.data || 'Update failed', 'error');
        }
      } else {
        setUploadStatus('error');
        showMessage('Invalid response from server', 'error');
      }
      
      // Clear file input
      e.target.value = '';
      
    } catch (error) {
      console.error('Error:', error);
      setUploadStatus('error');
      
      // Handle different error scenarios
      if (error.response) {
        // Server responded with error
        const errorMsg = error.response.data?.message || error.response.data?.data || error.message;
        showMessage(`Server Error: ${errorMsg}`, 'error');
        setApiResponse(error.response.data);
      } else if (error.request) {
        // Request made but no response
        showMessage('Network error - No response from server', 'error');
      } else {
        // Other errors
        showMessage(`Error: ${error.message}`, 'error');
      }
    } finally {
      setUploading(false);
    }
  };

  // Reset all
  const resetAll = () => {
    setExcelData([]);
    setFileName('');
    setUploadStatus(null);
    setApiResponse(null);
    document.getElementById('excel-upload').value = '';
    showMessage('Form reset successfully', 'info');
  };

  // Download error report if needed
  const downloadErrorReport = () => {
    if (!excelData.length) return;
    
    const report = {
      uploadTime: new Date().toISOString(),
      totalRecords: excelData.length,
      status: uploadStatus,
      apiResponse: apiResponse,
      data: excelData
    };
    
    const blob = new Blob([JSON.stringify(report, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `irn_update_report_${Date.now()}.json`;
    a.click();
    URL.revokeObjectURL(url);
    showMessage('Report downloaded', 'success');
  };

  return (
    <div>
      <Snackbar 
        open={open} 
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleClose} severity={severit} variant="filled">
          {message}
        </Alert>
      </Snackbar>
      
      <Home />
      <div style={{ paddingLeft: '80px' }} className='App'>
        <ItemPap>
          <div style={{ color: 'red', fontWeight: 'bold', fontSize: '23px', marginTop: '1%', marginBottom: '1%' }}>
            <center>IRN Update - Excel Upload</center>
          </div>
          
          <Grid container>
            <Grid item xs={12}>
              {/* Upload Section */}
              <Row className="mb-4">
                <Col xs={12}>
                  <Paper style={{ padding: '30px', backgroundColor: '#f8f9fa' }}>
                    <Form.Group>
                      <Form.Label style={mystyle1}>Select Excel File</Form.Label>
                      <Form.Control
                        id="excel-upload"
                        type="file"
                        accept=".xlsx,.xls,.csv"
                        onChange={handleFileUpload}
                        disabled={uploading}
                        style={mystyle}
                      />
                      <Form.Text className="text-muted">
                        Upload Excel file (.xlsx, .xls, .csv)
                      </Form.Text>
                    </Form.Group>
                    
                    {uploading && (
                      <div className="mt-4">
                        <LinearProgress />
                        <p className="mt-2 text-center">
                          Processing {fileName}...
                        </p>
                      </div>
                    )}
                  </Paper>
                </Col>
              </Row>

              {/* Status Display */}
              {uploadStatus && !uploading && (
                <Row className="mb-4">
                  <Col xs={12}>
                    <Paper style={{ padding: '20px' }}>
                      <h5 style={mystyle1}>Upload Status</h5>
                      
                      {uploadStatus === 'success' && (
                        <Alert severity="success" style={{ marginBottom: '15px' }}>
                          <strong>Success!</strong> IRN update completed successfully
                        </Alert>
                      )}
                      
                      {uploadStatus === 'error' && (
                        <Alert severity="error" style={{ marginBottom: '15px' }}>
                          <strong>Error!</strong> Failed to update IRN
                        </Alert>
                      )}
                      
                      {/* API Response Details */}
                      {apiResponse && (
                        <div style={{ marginTop: '15px' }}>
                          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <tbody>
                              <tr>
                                <td style={{ padding: '8px', fontWeight: 'bold', width: '150px' }}>Status:</td>
                                <td style={{ padding: '8px' }}>
                                  <span style={{ 
                                    color: apiResponse.status === 'success' ? 'green' : 'red',
                                    fontWeight: 'bold'
                                  }}>
                                    {apiResponse.status || 'N/A'}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '8px', fontWeight: 'bold' }}>Code:</td>
                                <td style={{ padding: '8px' }}>{apiResponse.code || 'N/A'}</td>
                              </tr>
                              <tr>
                                <td style={{ padding: '8px', fontWeight: 'bold' }}>Message:</td>
                                <td style={{ padding: '8px' }}>{apiResponse.data || apiResponse.message || 'N/A'}</td>
                              </tr>
                              <tr>
                                <td style={{ padding: '8px', fontWeight: 'bold' }}>Total Records:</td>
                                <td style={{ padding: '8px' }}>{excelData.length}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )}
                      
                      <div style={{ marginTop: '20px' }}>
                        <Button 
                          variant="outline-primary" 
                          onClick={resetAll}
                          size="sm"
                        >
                          Upload Another File
                        </Button>
                        
                        {excelData.length > 0 && (
                          <Button 
                            variant="outline-secondary" 
                            onClick={downloadErrorReport}
                            size="sm"
                            style={{ marginLeft: '10px' }}
                          >
                            Download Report
                          </Button>
                        )}
                      </div>
                    </Paper>
                  </Col>
                </Row>
              )}

              {/* Data Preview (Optional - shows uploaded data) */}
              {excelData.length > 0 && !uploading && uploadStatus === 'success' && (
                <Row className="mb-4">
                  <Col xs={12}>
                    <Paper style={{ padding: '20px', maxHeight: '400px', overflow: 'auto' }}>
                      <h5 style={mystyle1}>Uploaded Data Preview (First 5 records)</h5>
                      <table className="table table-bordered table-sm">
                        <thead style={{ backgroundColor: '#f0f0f0', position: 'sticky', top: 0 }}>
                          <tr>
                            <th>#</th>
                            {excelData[0] && Object.keys(excelData[0]).map((key, idx) => (
                              <th key={idx}>{key}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {excelData.slice(0, 5).map((record, idx) => (
                            <tr key={idx}>
                              <td>{idx + 1}</td>
                              {Object.values(record).map((value, idx2) => (
                                <td key={idx2}>{String(value).substring(0, 50)}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {excelData.length > 5 && (
                        <p className="text-muted text-center">
                          And {excelData.length - 5} more records...
                        </p>
                      )}
                    </Paper>
                  </Col>
                </Row>
              )}
            </Grid>
          </Grid>
        </ItemPap>
      </div>
    </div>
  );
}

export default IrnUpdate;